import React from "react";
import * as ReactDOMClient from "react-dom/client";

import { Root } from "components/Root";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOMClient.createRoot(document.getElementById("root")!);
root.render(<Root />);
